export const profileStorageUsageStyles = {
  container: {
    height: '450px',
    width: '100%',
  },
};
